/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  redactUrlParamsWithPossiblePii,
  sanitizeFieldsForTracking,
  urlContainsPossiblyBlacklistedPiiParams,
} from 'embed/constants/pii-handling'

function charOccurrenceCount(str: string, charToCount: string): number {
  let charCount = 0

  for (const char of str) {
    if (char === charToCount) {
      charCount += 1
    }
  }

  return charCount
}

export function containsPossibleStreetAddress(str: string): boolean {
  // Google Places street addresses will have at least 3 parts separated by commas
  return str && charOccurrenceCount(str, ',') > 2 ? true : false
}

export function redactPossiblePiiParamsFromQueryObject<T extends { [key: string]: unknown }>(urlQueryObject: T): T {
  if (urlQueryObject) {
    if (urlQueryObject.app) {
      // @ts-ignore
      urlQueryObject.app = sanitizeFieldsForTracking(urlQueryObject.app)
    }
    if (urlQueryObject.filter) {
      // @ts-ignore
      urlQueryObject.filter = sanitizeFieldsForTracking(urlQueryObject.filter)
    }
  }
  return urlQueryObject
}

export function redactPossiblePiiParamsFromUrlObjectKeyValue<T>(obj: T, key: keyof T) {
  const url = obj[key]
  if (urlContainsPossiblyBlacklistedPiiParams(url)) {
    // @ts-ignore
    obj[key] = redactUrlParamsWithPossiblePii(url)
  }
}
